import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { IQueryStorageItem } from 'app/query-builder/core/query-storage.service';
import { ToastrService } from 'core/toastr.service';

export interface ExportDialogData {
  query: IQueryStorageItem;
  recordCount?: number;
}
@Component({
  selector: 'app-export-dialog',
  template: `<div class="modal">
    <i class="fal fa-times modal__close" (click)="close()"></i>
    <app-export (exportSuccess)="close($event)" [query]="data.query" [recordCount]="data.recordCount"> </app-export>
    </div>`,
})
export class ExportDialog {
  constructor(
    private toastrService: ToastrService,
    public dialogRef: MatDialogRef<ExportDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ExportDialogData ) { }

  static open(dialog: MatDialog, config: MatDialogConfig<ExportDialogData>) {
    return dialog.open(ExportDialog, config);
  }

  // Close dialog and pass along event data.
  close(event = null) {
    if (event === true) {
      this.toastrService.success('A link to download the file will be emailed to you');
      this.dialogRef.close(event);
    }

    if (event === false) {
      this.toastrService.error('There was a problem exporting the file, please try again later.');
    }

    if (event === null || event === undefined) {
      this.dialogRef.close();
    }

  }
}
